import React from 'react'
import DefineAdSlot from '../../../components/Ads/DefineAdSlot'
import { adTierConfigs } from '../../../components/Ads/adTierConfigs'
import type { AdTier } from '../../../hooks/useAdTier'
import { useAdTargeting } from '../../../hooks/useAdTargeting'
import '../../styles/AdsModule/AdSlots.scss'

interface AdSlotsProps {
    tierName?: AdTier
    dynamicTargeting?: Record<string, string | string[]>
}

export const AdSlots = ({
  tierName = 'under25',
  dynamicTargeting = {}
}: AdSlotsProps) => {
  const currentTier = adTierConfigs[tierName]

  useAdTargeting(currentTier, dynamicTargeting)

  if (!currentTier) {
    console.warn(`AdSlots: Ad tier "${tierName}" not found in adTierConfigs.`)
    return null
  }

  const { baseAdUnitPath, slots } = currentTier

  return (
        <div className="ads-module__ads">
            <div className="ads-module__slots">
                {slots.map((slotConfig, index) => {
                  const slotId = `${tierName}-ad-${slotConfig.slotIdSuffix || index}`
                  const isPixelSlot = Array.isArray(slotConfig.size) &&
                    slotConfig.size[0] === 1 && slotConfig.size[1] === 1
                  return (
                        <div key={slotId} className={`ads-module__slot${isPixelSlot ? ' ads-module__slot--pixel' : ''}`}>
                            <DefineAdSlot
                                adUnitPath={baseAdUnitPath}
                                size={slotConfig.size}
                                slotId={slotId}
                                targeting={{
                                  position: slotConfig.position
                                }}
                            />
                        </div>
                  )
                })}
            </div>
            <div className="ads-module__disclosure-static">
                SmartAsset receives compensation from these third-parties for marketing their products or services or
                based on Users purchasing their products or services.
                SmartAsset&apos;s receipt of such compensation from these third-parties creates a conflict of interest for
                SmartAsset to provide information about third-parties that provide such compensation,
                rather than third-parties that do not provide such compensation.
            </div>
        </div>
  )
}
